<template>
  <search-results
    :searchTerm="searchTerm"
    :searchResults="searchResults"
    :searchCount="searchCount"
    :searching="searching"
    :searchFields="searchFields"
    @onSimpleSearch="handleSimpleSearch($event)"
    @onAdvancedSearch="handleAdvancedSearch($event)"
    @exportToFile="exportToFile">
  </search-results>
</template>

<script>
import { mapState } from 'vuex';

import SearchResults from '@/components/interaction/SearchResults';

import * as interactionTypes from '@/store/modules/interaction/mutation-types';

export default {
  name: 'InteractionSearchContainer',
  components: {
    SearchResults,
  },
  data: () => ({
    query: null,
    queryType: 'simple',
  }),
  computed: {
    ...mapState('interaction', [
      'searchTerm',
      'searchResults',
      'searchCount',
      'searching',
      'searchFields',
    ]),
  },
  mounted() {
    this.$store.dispatch('interaction/getSearchFields');
    this.query = this.searchTerm;
  },
  methods: {
    handleSimpleSearch(event) {
      this.$store.commit(
        `interaction/${interactionTypes.SET_SEARCH_TERM}`,
        event.searchTerm,
      );
      this.$store.dispatch('interaction/simpleSearch', {
        query: event.searchTerm,
        page: 1,
      });
      this.query = event.searchTerm;
      this.queryType = 'simple';
    },

    handleAdvancedSearch(event) {
      this.query = event;
      this.$store.dispatch('interaction/advancedSearch', {
        query: event,
        page: 1,
      });
      this.queryType = 'segmented';
    },

    exportToFile(filename) {
      let data = {
        type: this.queryType,
        query: this.query,
        file_name: filename,
      };

      if (this.$route.params.campaignId) {
        data = {
          type: this.queryType,
          query: this.query,
          file_name: filename,
          campaign_id: this.$route.params.campaignId,
        };
      }

      this.$store.dispatch('interaction/exportToFile', data);
    },
  },
  watch: {
    searchTerm(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.query = this.searchTerm;
        this.queryType = 'simple';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// InteractionSearchContainer.vue?222f0688